import {getRestProps} from '../utils';

export default function(obj, _Vdt, blocks, $callee) {
    _Vdt || (_Vdt = Vdt);
    obj || (obj = {});
    blocks || (blocks = {});
    var h = _Vdt.miss.h, hc = _Vdt.miss.hc, hu = _Vdt.miss.hu, widgets = this && this.widgets || {}, _blocks = {}, __blocks = {},
        __u = _Vdt.utils, extend = __u.extend, _e = __u.error, _className = __u.className, __slice = __u.slice, __noop = __u.noop,
        __m = __u.map, __o = __u.Options, _getModel = __o.getModel, _setModel = __o.setModel,
        _setCheckboxModel = __u.setCheckboxModel, _detectCheckboxChecked = __u.detectCheckboxChecked,
        _setSelectModel = __u.setSelectModel,
        self = this.data, $this = this, scope = obj, Animate = self && self.Animate, parent = ($callee || {})._super;

    const {className, children, type, size} = self.get();

const classNameObj = {
    'k-item': true,
    [className]: className,
    [`k-${type}`]: true,
    [`k-${size}`]: size !== 'default',
};

    return h('div', {
        ...function() {try {return (getRestProps(self) )} catch(e) {_e(e)}}.call($this)
    }, [
        h('div', null, [
            h('div', null, (_blocks['dot'] = function(parent) {
                return h('div', null, null, 'k-circle');
            }) && (__blocks['dot'] = function(parent) {
                var args = arguments;
                return blocks['dot'] ? blocks['dot'].apply($this, [function() {
                    return _blocks['dot'].apply($this, args);
                }].concat(__slice.call(args, 1))) : _blocks['dot'].apply($this, args);
            }) && __blocks['dot'].apply($this, [__noop]), 'k-dot'),
            h('div', null, null, 'k-line')
        ], 'k-indicator'),
        h('div', null, function() {try {return (children )} catch(e) {_e(e)}}.call($this), 'k-content')
    ], _className(function() {try {return (classNameObj )} catch(e) {_e(e)}}.call($this)))
}